function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */
import { ModalCloseButton as ChakraModalCloseButton } from '@chakra-ui/modal';
import { forwardRef } from '@chakra-ui/system';
import { CloseButton } from '@fluidtruck/close-button';
import * as React from 'react';
export var ModalCloseButton = forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(ChakraModalCloseButton, _extends({
    as: CloseButton
  }, props, {
    ref: ref
  }));
});
//# sourceMappingURL=modal-close-button.js.map